export default "__VITE_ASSET__BViSx4pf__"